import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/solutions", label: "Solutions" },
  { to: "/products", label: "Products" },
  { to: "/blog", label: "Blog" },
  { to: "/faq", label: "FAQ" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="fixed top-0 inset-x-0 z-50 border-b border-[#eef1f7] bg-white shadow-[0_6px_24px_-10px_rgba(8,22,168,0.18)]">
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-2 lg:px-10">
        <Link to="/" data-testid="nav-logo" className="flex items-center" onClick={() => setOpen(false)}>
          <img src="/logo.png" alt="Vowpin Global" className="h-20 w-auto" />
        </Link>

        <div className="hidden items-center gap-8 lg:flex">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors duration-200 hover:text-[#0816a8] ${
                  isActive ? "text-[#0816a8]" : "text-[#374151]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            data-testid="nav-talk-to-sales-btn"
            className="group flex items-center gap-2 rounded-full bg-[#0816a8] px-5 py-2.5 text-sm font-semibold text-white shadow-[0_8px_24px_-8px_rgba(8,22,168,0.5)] transition-all duration-300 hover:bg-[#0a1bc4] hover:shadow-[0_12px_32px_-8px_rgba(8,22,168,0.6)]"
          >
            Talk to Sales
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
          </Link>
        </div>

        <button
          data-testid="nav-mobile-menu-btn"
          className="lg:hidden text-[#374151]"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </nav>

      {open && (
        <div className="border-t border-[#e8ecf4] bg-white px-6 py-6 shadow-lg lg:hidden" data-testid="nav-mobile-menu">
          <div className="flex flex-col gap-5">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`nav-mobile-${l.label.toLowerCase()}`}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `text-base font-medium ${isActive || location.pathname === l.to ? "text-[#0816a8]" : "text-[#374151]"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              data-testid="nav-mobile-talk-to-sales-btn"
              onClick={() => setOpen(false)}
              className="mt-2 flex w-fit items-center gap-2 rounded-full bg-[#0816a8] px-6 py-3 text-sm font-semibold text-white"
            >
              Talk to Sales
              <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
